import React, { Component } from 'react';
import $ from 'jquery';
import config from "../config";
import { gapi } from 'gapi-script';
import axios from 'axios';
import moment from 'moment';
import { ulid } from 'ulid';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, TextField, Table, TableSortLabel, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {DebounceInput} from 'react-debounce-input';


export default class TestReviewManager extends Component {
	
	constructor(props){
        super(props)
		this.state ={
			selectedFiles:new Map(),
			assigedLayouts:[],
			instanceIds:[],
			childSheets:[],
			searchQuery:'',
			selectedUser:'',
			page:0,
			rowsPerPage:10,
		}

    }
	
	componentDidMount() {
		this.getLoginUsers();
		this.reloadData();
	}
	
	reloadData=()=>{
		let that = this;
		setTimeout(function(){
			let sheets = that.props.childSheets;
			that.setState({childSheets:sheets});
			that.getResponseReviews(sheets);
		}, 3000);
		setTimeout(function(){
			that.getResponseReviews();
		}, 2000);
	}
	
	getResponseReviews=()=>{
		let sheets = this.state.childSheets;
		if(sheets){
			let mdsToCheck = this.state.page * this.state.rowsPerPage;
			let limit = this.state.page * this.state.rowsPerPage + 10;
			let layoutGuids = [];
			sheets.map((sheet,i)=>{
				if(i >= mdsToCheck && i < limit){
					layoutGuids.push(sheet.LayoutGuid);
				}
			}); 
			
			if(layoutGuids){
				let mongoApiUrl = config.mongoApiUrl;
				let url = mongoApiUrl+'form-test-response';
				axios({
					method: 'POST',
					url: url,
					data: JSON.stringify(layoutGuids),
					headers: {
						'Content-Type': 'application/json',
					}
				})
				.then(response => {
					let rs = response.data.Response;
					let rv = response.data.Reviews;
					
					
					sheets.map((sheet,i)=>{
						//console.log('rs->',rs[sheet.LayoutGuid]);
						if(rs[sheet.LayoutGuid]){
							sheet.Response = rs[sheet.LayoutGuid];
						}
						if(rv[sheet.LayoutGuid]){
							sheet.hasReview = true;
							sheet.Reviews = rv[sheet.LayoutGuid];
						}
					});
					
					this.setState({childSheets:sheets});
				}).catch(error => {
					console.log('error::', error);
				})
			}
			
		}
	}
	
	getValue=(event)=>{
		
		let name = event.target.name;
		let res = event.target.value;
		let that = this;
		this.setState({[event.target.name]:event.target.value});
		if(name == 'selectedUser'){
			$("input[name='customSwitch1']").prop('checked', false);
			$(".layout-ma-list").show();
			let assigedLayouts = this.state.assigedLayouts;
			let instanceIds = this.state.instanceIds;
			//console.log('assigedLayouts->',assigedLayouts);
			if(assigedLayouts){
				assigedLayouts.map((val,i)=>{
					this.setState({[val]:false});
				})
			}
			this.setState({assigedLayouts:[],instanceIds:[]});
			let that = this;
			setTimeout(function(){
				that.UserLayouts(res);
			}, 1000);
		}
		
		if(name == 'selectedInstance'){
			this.props.getValue2(event);
			this.setState({childSheets:[]});
			setTimeout(function(){
				that.props.getLayoutSheetsV2(that.props.selectedInstanceId);
				that.reloadData();
			}, 2000);
		}

	}
	
	uniqueArray2(arr) {
		var a = [];
		for (var i=0, l=arr.length; i<l; i++)
			if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
				a.push(arr[i]);
		return a;
	}
	
	setUploadToMongo=(event)=>{
		let sheet = event.target.name;
		let type = event.target.id;
		let selectedFiles = this.state.selectedFiles;
		
		if($("#"+type).prop("checked") == true){
			selectedFiles.set(type,sheet);
			this.setState({[type]:true});
		}else{
			selectedFiles.delete(type);
			this.setState({[type]:false});
		}
		
		this.setState({selectedFiles});
	}
	
	getLoginUsers=()=>{
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'login-users';
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let users = response.data;
			this.setState({users});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	convertSecondstoTime(val) {
		let dateObj = new Date(val * 1000);
		let hours = dateObj.getUTCHours();
		let minutes = dateObj.getUTCMinutes();
		let seconds = dateObj.getSeconds();

		/* let timeString = hours.toString().padStart(2, '0')
			+ ':' + minutes.toString().padStart(2, '0')
			+ ':' + seconds.toString().padStart(2, '0'); */
			
		let timeString = minutes.toString().padStart(2, '0')
			+ ':' + seconds.toString().padStart(2, '0');

		return timeString;
	}
	
	filterTrackType=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		this.setState({[name]:value});
		$('.lfilter option:selected').prop("selected", false);
		if(value){
			$(".layout-ma-list").hide();
			let childSheets = this.props.childSheets;
			childSheets.map((sheet,i)=>{
				let Track = sheet.Track ? sheet.Track : [];
				if(Track.indexOf(value) != -1){
					$("#form-"+sheet.LayoutGuid).show();
				}
			})
		}else{
			$(".layout-ma-list").show();
		}
	}
	
	filterLayoutType=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		this.setState({[name]:value});
		let childSheets = this.props.childSheets;
		let layoutType = this.state.layoutType;
		let layoutDeviceType = this.state.layoutDeviceType;
		let layoutVisitType = this.state.layoutVisitType;
		let layoutTrack = this.state.layoutTrack;
		
		if(name == 'layoutType'){
			layoutType = value;
		}else if(name == 'layoutDeviceType'){
			layoutDeviceType = value;
		}else if(name == 'layoutVisitType'){
			layoutVisitType = value;
		}
		
		if(layoutType || layoutDeviceType || layoutVisitType || layoutTrack){
			$(".layout-ma-list").hide();
			childSheets.map((sheet,i)=>{
				let Types = sheet.Types ? sheet.Types : [];
				let dTypes = sheet.DeviceTypes ? sheet.DeviceTypes : [];
				let vTypes = sheet.VisitTypes ? sheet.VisitTypes : [];
				
				if(layoutType && layoutDeviceType && layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && dTypes.indexOf(layoutDeviceType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(layoutType && layoutDeviceType && !layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && dTypes.indexOf(layoutDeviceType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(layoutType && !layoutDeviceType && layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(!layoutType && layoutDeviceType && layoutVisitType){
					if(dTypes.indexOf(layoutDeviceType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(layoutType && !layoutDeviceType && !layoutVisitType){
					if(Types.indexOf(layoutType) != -1 ){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(!layoutType && layoutDeviceType && !layoutVisitType){
					if(dTypes.indexOf(layoutDeviceType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(!layoutType && !layoutDeviceType && layoutVisitType){
					if(vTypes.indexOf(layoutVisitType) != -1){
						$("#form-"+sheet.LayoutGuid).show();
					}
				}
				
				if(layoutTrack){
					let Track = sheet.Track ? sheet.Track : [];
					if(Track.indexOf(layoutTrack) == -1){
						$("#form-"+sheet.LayoutGuid).hide();
					}
				}
			})
			
		}else{
			$(".layout-ma-list").show();
		}
		
		
	}
	
	assignLayoutToUser=(event)=>{
		let selectedInstanceId = this.props.selectedInstanceId;
		let layoutGuid = event.target.name;
		let selectedUser = this.state.selectedUser;
		if(!selectedUser){
			alert('Please select user first!');
			return false;
		}
		
		if($("#"+layoutGuid).prop("checked") == true){
			this.setState({[layoutGuid]:true});
			this.layoutToUser('add',selectedUser,layoutGuid,selectedInstanceId);
		}else if($("#"+layoutGuid).prop("checked") == false){
			this.layoutToUser('delete',selectedUser,layoutGuid,selectedInstanceId);
			this.setState({[layoutGuid]:false});
		}
		
		//this.setState({selectedFiles});
		
	}
	
	assignAllLayoutToUser=(event)=>{
		
		let user = this.state.selectedUser;
		if(!user){
			alert('Please select user first!');
			$("#formAllSelect").prop('checked', false);
			return false;
		}
		
		if($("#formAllSelect").prop("checked") == true){
			let layouts = [];
			this.props.childSheets.map((sheet,i)=>{
				layouts.push(sheet.LayoutGuid);
			})
			if(layouts){
				this.allLayoutToUser(user,layouts);
			}
		}else if($("#formAllSelect").prop("checked") == false){
			let emptylayouts=[]
			this.props.childSheets.map((sheet,i)=>{
				this.setState({[sheet.LayoutGuid]:false});
			})
			this.allLayoutToUser(user,emptylayouts);
		}
	}
	
	allLayoutToUser=(user,assLayouts)=>{
		
		if(user && assLayouts){
			let fieldData = {
				"UserName": user,
				"Layouts": assLayouts
			}
			
			let mongoApiUrl = config.mongoApiUrl;
			let url = mongoApiUrl+'assign-layout';
			axios({
				method: 'POST',
				url: url,
				data: fieldData,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				this.UserLayouts(user);
				//console.log('response::', response.data);
			}).catch(error => {
				console.log('error::', error);
			})
		}
	}
	
	layoutToUser=(type,user,layout,selectedInstanceId)=>{
		
		let assigedLayouts = this.state.assigedLayouts;
		let instanceIds = this.state.instanceIds;
		let instance = selectedInstanceId+'-'+layout;
		if(type == 'add'){
			assigedLayouts.push(layout);
			instanceIds.push(instance);
		}else if(type == 'delete'){
			let removeItem = layout;
			assigedLayouts = $.grep(assigedLayouts, function(value) {
			  return value != removeItem;
			});
			
			let removeIns = instance;
			if(instanceIds.length > 0){
				instanceIds = $.grep(instanceIds, function(value) {
				  return value != removeIns;
				});
			}
			
			this.setState({assigedLayouts,instanceIds});
		}
		
		let assLayouts = this.uniqueArray2(assigedLayouts);
		let assInstances = this.uniqueArray2(instanceIds);
		
		if(user && assLayouts){
			let fieldData = {
				"UserName": user,
				"Layouts": assLayouts,
				"assInstances": assInstances
			}
			
			let mongoApiUrl = config.mongoApiUrl;
			let url = mongoApiUrl+'assign-layout';
			axios({
				method: 'POST',
				url: url,
				data: fieldData,
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				//console.log('response::', response.data);
			}).catch(error => {
				console.log('error::', error);
			})
		}
	}
	
	UserLayouts=(user)=>{
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'user-layouts/'+user;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			if(data){
				let Layouts = data.Layouts;
				if(Layouts){
					let assigedLayouts = this.state.assigedLayouts;
					let instanceIds = this.state.instanceIds;
					this.setState({assigedLayouts:Layouts,instanceIds:data.assInstances ? data.assInstances : []});
					Layouts.map((val,i)=>{
						this.setState({[val]:true});
					})
				}
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	showInTemplate=(event)=>{
		let layoutGuid = event.target.name;
		let ShowTemp = false;
		if($("#template-"+layoutGuid).prop("checked") == true){
			this.setState({['template-'+layoutGuid]:true});
			ShowTemp = true;
		}else if($("#template-"+layoutGuid).prop("checked") == false){
			this.setState({['template-'+layoutGuid]:false});
		}
		
		//this.setState({selectedFiles});
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'show-in-template';
		let data = {
			"LayoutGuid": layoutGuid,
			"ShowTemp": ShowTemp,
		}
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response);
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	

	handleChangePage = (event: unknown, newPage: number) => {
		this.setState({page:newPage});
		let that = this;
		setTimeout(function(){
			that.getResponseReviews();
		}, 1000);
		
	};

	handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({rowsPerPage:event.target.value,page:0});
	};
	
	handleSort = column => {
		const { sortBy, sortOrder } = this.state;
		const isAsc = sortBy === column && sortOrder === 'asc';
		this.setState({
		  sortBy: column,
		  sortOrder: isAsc ? 'desc' : 'asc'
		});
	};
	
	handleSearch = (event) => {
		let that = this;
		this.setState({searchQuery:event.target.value});
		setTimeout(function(){
			that.filterMdsForms();
		}, 1000);
    };

	filterMdsForms=()=>{
		let childSheets = this.props.childSheets;
		let childForms = [];
		let assigedLayouts = this.state.assigedLayouts;
		childSheets.map((sheet,i)=>{
			if(this.state.showAssignedForms && assigedLayouts.indexOf(sheet.LayoutGuid) == -1){
				return false;
			}
			childForms.push(sheet);
		});
		
		let searchQuery = this.state.searchQuery;
		if(searchQuery){
			childForms = childForms.filter((row) =>
				row.LayoutName.toLowerCase().includes(searchQuery.toLowerCase())
			);
		} 
		this.setState({childSheets:childForms});
	}
	
	
	
	showAssignedForms=()=>{
		let showAssignedForms = this.state.showAssignedForms;
		if($("input[name='customSwitch1']").prop("checked") == true){
			this.setState({showAssignedForms:true});
		}else{
			this.setState({showAssignedForms:false});
		}
		let that = this;
		setTimeout(function(){
			that.filterMdsForms();
		}, 1000);
	}
	
	render() {
		const {flayoutTypes,fdeviceTypes,fvisitTypes,ftrack,selectedInstanceId,searchQuery} = this.props;
		const {childSheets,users,selectedUser,sortBy,sortOrder} = this.state;
		console.log('childSheets->',childSheets); 
		let optionInstance = '';
		if(this.props.instancesList){
			let ins = this.props.instancesList;
			optionInstance = ins.map(function(val,i) {
				return (
						<MenuItem value={val.InstanceGuild} key={i}>{val.InstanceName}</MenuItem>
					);
			})
		}
		
		const StyledTableCell = styled(TableCell)(({ theme }) => ({
		  [`&.${tableCellClasses.head}`]: {
			//backgroundColor: '#e9e9e9',
			color: '#000;',
			padding: '15px 10px;',
			fontWeight: 600,
			//fontSize: 15,
		  },
		  [`&.${tableCellClasses.body}`]: {
			//fontSize: 16,
			padding: '10px',
			backgroundColor: '#ffffff',
		  },
		}));
		
		const sortedData = [...childSheets].sort((a, b) => {
		  const isAsc = sortOrder === 'asc';
		  if (a[sortBy] < b[sortBy]) {
			return isAsc ? -1 : 1;
		  }
		  if (a[sortBy] > b[sortBy]) {
			return isAsc ? 1 : -1;
		  }
		  return 0;
		});
		
		//console.log('childSheets::', childSheets);
		let optionUsers = '';
		let reviewFields = 0;
		
		if(users){
			optionUsers = users.map(function(val,i) {
				if(val.role != 'Administrator'){
				return (
					<MenuItem value={val.username} key={i}>{val.username+'('+val.role+')'}</MenuItem>
				);
				}
				
			})
		}
		
		let href = window.location.href.split('?')[0];
		
		return (
			<div className="mds-manager-mongo custom-container">
				
				<div className="mongo-header">
					
					<div className="mg-page-title"><h4>Form Test and Review Manager</h4></div>
						{/* this.state.selectedUser ? 
						<div className="wp-check-filter">
							<div className="show-output-txt">
								<label className="showAllSwitch">
									<input id="showAssignedForms" type="checkbox" name="showAssignedForms" onClick={this.showOnlyAssigned}/>
									<span className="slider round showAllSlide"></span>
								</label>
							</div>
						</div>
						:null */}
						<div className="wp-mode-filter">
							<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
								<InputLabel>Select User</InputLabel>
								<Select
									value={this.state.selectedUser}
									name={'selectedUser'}
									onChange={this.getValue}
									input={<OutlinedInput label="Select User" />}
								>
								{optionUsers}
								</Select>
							</FormControl>
						</div>
						
						<div className="wp-mode-filter">
							<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
								<InputLabel>Select Instance</InputLabel>
								<Select
									value={this.state.selectedInstance ?  this.state.selectedInstance : this.props.selectedInstanceId}
									name={'selectedInstance'}
									onChange={this.getValue}
									input={<OutlinedInput label="Select Instance" />}
								>
								{optionInstance}
								</Select>
							</FormControl>
						</div> 
						
						<div className="wp-search-filter">
							<DebounceInput debounceTimeout={500} type="text" className="form-control" name="searchQuery" value={searchQuery} onChange={this.handleSearch} placeHolder="Search" />
							<span className="search-icon"><i className="fa fa-search" aria-hidden="true"></i></span>
						</div>
						
						{/*<div className="col-md-2 col-lg-2 col-6 col-filter">
							<div className="form-group">
								<label>Track</label>
								<select className="form-control" name="layoutTrack" onChange={this.filterTrackType}>
									<option value="">Please Select</option>
									{ftrack.map((val, i) => (
										<option key={i} value={val}>{val}</option>
									))}
								</select>
							</div>
						</div>
					
						<div className="col-md-2 col-lg-2 col-6 col-filter">
							<div className="form-group">
								<label>Type</label>
								<select className="form-control lfilter" name="layoutType" onChange={this.filterLayoutType}>
									<option value="">Please Select</option>
									{flayoutTypes.map((val, i) => (
										<option key={i} value={val}>{val}</option>
									))}
								</select>
							</div>
						</div>
						
						<div className="col-md-2 col-lg-2 col-6 col-filter">
							<div className="form-group">
								<label>Device Type</label>
								<select className="form-control lfilter" name="layoutDeviceType" onChange={this.filterLayoutType}>
									<option value="">Please Select</option>
									{fdeviceTypes.map((val, i) => (
										<option key={i} value={val}>{val}</option>
									))}
								</select>
							</div>
						</div>
						<div className="col-md-2 col-lg-2 col-6 col-filter">
							<div className="form-group">
								<label>Visit Type</label>
								<select className="form-control lfilter" name="layoutVisitType" onChange={this.filterLayoutType}>
									<option value="">Please Select</option>
									{fvisitTypes.map((val, i) => (
										<option key={i} value={val}>{val}</option>
									))}
								</select>
							</div>
						</div>*/}
						
						
				</div>
				
				{/* childSheets ?
				<div className="tst-child-sheets">
					<div className="scroll-box">
						<div className="tst-top-action-icon">
							{ selectedUser ?
							<div className="custom-control custom-switch text-right">
							  <input type="checkbox" className="custom-control-input" id="customSwitch1" name="customSwitch1" onClick={this.showAssignedForms} />
							  <label className="custom-control-label" for="customSwitch1">Only Assigned Forms</label>
							</div>
							:null}
							<table className="table test-review-table">
								<thead>
								<tr> 
									<th>Layout Name</th>
									<th>Friendly Name</th>
									<th>Rating </th>
									<th>Assign for Testing</th>
									<th>Show in Templates</th>
									<th>Tested</th>
									<th>Test Time</th>
									<th>Reviewed</th>
									<th>Fields</th>
									<th>Review Time</th>
								</tr>
								</thead>
								<tbody>
									{childSheets.map((sheet, i) => {
										let sheetGuid = sheet.LayoutGuid;
										let reviewCount = '';
										let classn = '';
										let mdsClass = '';
										let formReview = '';
										let testTile = '';
										let totalTime = '';
										let totalFields = '';
										let userName = '';
										let starScore = 0;
										
										if(sheet.Response){
											if(sheet.Response.ResponseID){
												
												
												userName = sheet.Response.UserName;
												starScore = sheet.Response.StarScore;
												
												var t1 = new Date(sheet.Response.StartTime);
												var t2 = new Date(sheet.Response.EndTime);
												var seconds = (t2 - t1) / 1000;
												
												//console.log('sheet->',sheet);
												//console.log('seconds->',seconds);
												
												if(seconds){
													totalTime = this.convertSecondstoTime(seconds);
												}
												if(sheet.hasReview == true){
													formReview = 'has-review';
													//reviewFields = sheet.Response.reviewFields;
													reviewCount = sheet.Reviews.length; 
													
												}

											}
										
										
											let totalStar = [1,2,3,4,5];
											
											let starHtml = totalStar.map(function(val,i) {
												if(val <= starScore){
													return (
														<i className="fa fa-star rated"></i>
													);
												}else{
													return (
														<i className="fa fa-star-o"></i>
													);
												}
												
											})
											
											
											let lastUpdate = new Date(sheet.ModifiedDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
											
											return(<tr id={'form-'+sheetGuid} key={i} className={"show layout-ma-list"}>
												<td>{sheet.LayoutName} </td>
												<td>{sheet.FriendlyName} </td>
												<td>{starHtml}</td>
												<td><input id={sheetGuid} type="checkbox" name={sheetGuid} checked={classn == 'has-in-mongo' || this.state[sheetGuid] ? 'checked' : ''} onChange={this.assignLayoutToUser} /></td>
												<td><input id={'template-'+sheetGuid} type="checkbox" name={sheetGuid} checked={sheet.showInTemplate || this.state['template-'+sheetGuid] ? 'checked' : ''} onChange={this.showInTemplate} /></td>
												{mdsClass == 'has-in-mongo' ? 
													<td><div data-target={"#layoutDataModal"+sheetGuid} data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle has-in-mongo"} aria-hidden="true"></i></div></td>
												:
													<td><div data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></div></td>
												}
												<td><div data-toggle="modal">{ mdsClass == 'has-in-mongo' ?  totalTime : ''}</div></td>
												{formReview == 'has-review' ? 
													<td><i id={'guid-'+sheetGuid} className={"fa fa-circle has-in-mongo"} aria-hidden="true"></i><img src={href+'/review-2.png'} className="review-img" alt="Field Review" onClick={()=>this.props.improveMode(sheetGuid,sheet.LayoutName)} /> ({reviewCount})</td>
												:
													<td><div className="tst-mongo-val2" data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></div></td>
												}
												<td><div className="tst-mongo-val2" data-toggle="modal">{ formReview == 'has-review' && reviewFields != 0 ?  reviewFields : ''}</div></td>
												<td>
													<div className="tst-mongo-val2" data-toggle="modal">{ formReview == 'has-review' ?  totalTime : ''}</div>
													<div className="modal" id={"layoutDataModal"+sheetGuid} role="dialog">
														<div className="modal-dialog modal-lg">
															<div className="modal-content">
															  <div className="modal-header">
																<h5> Layout Name: {sheet.LayoutName} </h5>
																<button type="button" className="close" data-dismiss="modal">&times;</button>
															  </div>
															  <div className="modal-body">
																	<table className="layout-tbl table-bordered">
																	  <tr>
																		<th>Start Time</th>
																		<th>Finish Time</th>
																		<th>Total minutes to complete form</th>
																	  </tr>
																	  <tr>&nbsp;</tr>
																	  <tr>
																		<td>{sheet.Response.StartTime}</td>
																		<td>{sheet.Response.EndTime}</td>
																		<td>{totalTime}</td>
																	  </tr>
																	</table>
															  </div>
															</div>
														</div>
													</div>
												</td>
											</tr>)
										}
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				:null */}
				
				
				{childSheets ?
				<div className="mg-child-sheets">
				{ selectedUser ?
					<div className="custom-control custom-switch text-right">
					  <input type="checkbox" className="custom-control-input" id="customSwitch1" name="customSwitch1" onClick={this.showAssignedForms} />
					  <label className="custom-control-label" for="customSwitch1">Only Assigned Forms</label>
					</div>
				:null}
				<TableContainer>
				  <Table size="small" aria-label="a dense table">
					<TableHead>
					  <TableRow key={11}>
						<StyledTableCell>Layout Name</StyledTableCell>
						<StyledTableCell>Friendly Name</StyledTableCell>
						<StyledTableCell>Rating </StyledTableCell>
						<StyledTableCell>Assign for Testing</StyledTableCell>
						<StyledTableCell>Show in Templates</StyledTableCell>
						<StyledTableCell>Tested</StyledTableCell>
						<StyledTableCell>Test Time</StyledTableCell>
						<StyledTableCell>Reviewed</StyledTableCell>
						<StyledTableCell>Fields</StyledTableCell>
						<StyledTableCell>Review Time</StyledTableCell>
					  </TableRow>
					</TableHead>
					<TableBody>
					  {sortedData.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((sheet) => {
						
						let sheetGuid = sheet.LayoutGuid;
						let reviewCount = '';
						let classn = '';
						let mdsClass = '';
						let formReview = '';
						let testTile = '';
						let totalTime = '';
						let totalFields = '';
						let userName = '';
						let starScore = 0;
						if(sheet.Response){
							if(sheet.Response.ResponseID){
								
								mdsClass = 'has-in-mongo';
								
								userName = sheet.Response.UserName;
								starScore = sheet.Response.StarScore;
								
								var t1 = new Date(sheet.Response.StartTime);
								var t2 = new Date(sheet.Response.EndTime);
								var seconds = (t2 - t1) / 1000;
								
								if(seconds){
									totalTime = this.convertSecondstoTime(seconds);
								}
							}
						}
						
						if(sheet.hasReview == true){
							formReview = 'has-review';
							//reviewFields = sheet.Response.reviewFields;
							reviewCount = sheet.Reviews.length; 
							
						}
						
						let totalStar = [1,2,3,4,5];
							
						let starHtml = totalStar.map(function(val,i) {
							if(val <= starScore){
								return (
									<i className="fa fa-star rated"></i>
								);
							}else{
								return (
									<i className="fa fa-star-o"></i>
								);
							}
							
						})
						
						let lastUpdate = new Date(sheet.ModifiedDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
											
						
						return (<TableRow id={'form-'+sheetGuid} key={sheetGuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
							<StyledTableCell>{sheet.LayoutName} </StyledTableCell>
							<StyledTableCell>{sheet.FriendlyName} </StyledTableCell>
							<StyledTableCell>{starHtml}</StyledTableCell>
							<StyledTableCell><input id={sheetGuid} type="checkbox" name={sheetGuid} checked={classn == 'has-in-mongo' || this.state[sheetGuid] ? 'checked' : ''} onChange={this.assignLayoutToUser} /></StyledTableCell>
							<StyledTableCell><input id={'template-'+sheetGuid} type="checkbox" name={sheetGuid} checked={sheet.showInTemplate || this.state['template-'+sheetGuid] ? 'checked' : ''} onChange={this.showInTemplate} /></StyledTableCell>
							{mdsClass == 'has-in-mongo' || formReview == 'has-review' ? 
								<StyledTableCell><div data-target={"#layoutDataModal"+sheetGuid} data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle has-in-mongo"} aria-hidden="true"></i></div></StyledTableCell>
							:
								<StyledTableCell><div data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></div></StyledTableCell>
							}
							<StyledTableCell><div data-toggle="modal">{ mdsClass == 'has-in-mongo' ?  totalTime : ''}</div></StyledTableCell>
							{formReview == 'has-review' ? 
								<StyledTableCell><i id={'guid-'+sheetGuid} className={"fa fa-circle has-in-mongo"} aria-hidden="true"></i><img src={href+'/review-2.png'} className="review-img" alt="Field Review" onClick={()=>this.props.improveMode(sheetGuid,sheet.LayoutName)} /> ({reviewCount})</StyledTableCell>
							:
								<StyledTableCell><div className="tst-mongo-val2" data-toggle="modal"><i id={'guid-'+sheetGuid} className={"fa fa-circle not-in-mongo"} aria-hidden="true"></i></div></StyledTableCell>
							}
							<StyledTableCell><div className="tst-mongo-val2" data-toggle="modal">{ formReview == 'has-review' && reviewFields != 0 ?  reviewFields : ''}</div></StyledTableCell>
							<StyledTableCell>
								<div className="tst-mongo-val2" data-toggle="modal">{ formReview == 'has-review' ?  totalTime : ''}</div>
								<div className="modal" id={"layoutDataModal"+sheetGuid} role="dialog">
									<div className="modal-dialog modal-lg">
										<div className="modal-content">
										  <div className="modal-header">
											<h5> Layout Name: {sheet.LayoutName} </h5>
											<button type="button" className="close" data-dismiss="modal">&times;</button>
										  </div>
										  <div className="modal-body">
												<table className="layout-tbl table-bordered">
												  <tr>
													<th>Start Time</th>
													<th>Finish Time</th>
													<th>Total minutes to complete form</th>
												  </tr>
												  <tr>&nbsp;</tr>
												  <tr>
													<td>{sheet.Response.StartTime}</td>
													<td>{sheet.Response.EndTime}</td>
													<td>{totalTime}</td>
												  </tr>
												</table>
										  </div>
										</div>
									</div>
								</div>
							</StyledTableCell>
						  
						</TableRow>)
					  })}
					</TableBody>
				  </Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 20, 50, 100]}
					component="div"
					count={childSheets.length}
					rowsPerPage={this.state.rowsPerPage}
					page={this.state.page}
					onPageChange={this.handleChangePage}
					onRowsPerPageChange={this.handleChangeRowsPerPage}
				/>
				
				</div>
				:null}
				
				
			</div>
		);	
	}	
}
